import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { enableProdMode } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { IonicSelectableModule } from 'ionic-selectable';
import { AddkidComponent } from './components/addkid/addkid.component';
import { FormsModule } from '@angular/forms';
import { AvatarselectComponent } from './components/avatarselect/avatarselect.component';
import { AddtestComponent } from './components/addtest/addtest.component';
import { GenericpopupComponent } from './components/genericpopup/genericpopup.component';
import { ExamService } from './exam.service';
import { ResultshistoryComponent } from './components/resultshistory/resultshistory.component';
import { SwitchuserComponent } from './components/switchuser/switchuser.component';
import { AuthPopupComponent } from './components/auth-popup/auth-popup.component';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Import BrowserAnimationsModule
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeRo from '@angular/common/locales/ro';
registerLocaleData(localeRo);
enableProdMode();

@NgModule({
  declarations: [AppComponent, AddkidComponent, AvatarselectComponent, AddtestComponent,
    GenericpopupComponent, ResultshistoryComponent, SwitchuserComponent, AuthPopupComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, HttpClientModule, IonicSelectableModule, FormsModule, BrowserAnimationsModule],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, ExamService, DatePipe, { provide: LOCALE_ID, useValue: 'ro' }],
  bootstrap: [AppComponent],
})
export class AppModule { }
